<template>
  <div class="pxcx">
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i3"></i></div><p>评选程序</p>
    </div>

    <div class="pxcx_detail">
      <div class="title_big">安永及复旦评委会将通过严格的选拔程序，<br>确定最终获奖企业名单。</div>
      <p class="title_sm">评委会成员是由安永合伙人和复旦大学管理学院资深专家和学者组成。<br>当收到提名后，我们将根据被提名企业提供的资料对其进行评估。<br>
我们会安排与被提名人会面，以获取更多资料，再供评委会评议。</p>
      <p class="title_sm">对于被提名企业，评委会将着重评估如下几个方面：</p>
      <div class="icon_wrap clearfix">
        <div class="icon_item i1">
          
        </div>
        <div class="icon_item i2">
          
        </div>
        <div class="icon_item i3">
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'zxxy'
}
</script>

<style scoped>
  i.i3{
    width: 0.38rem;
    height: 0.38rem;
    background-position: -2.18rem -0.7rem;
  }
  .pxcx_detail{
    padding: 0 0rem 0 0.42rem;
  }
  .title_big{
    font-size: 0.24rem;
    color: #6d6e71;
    margin-bottom: 0.32rem;
  }
  .title_sm{
    color: #231f20;
    font-size: 0.1822rem;
    margin-bottom: 0.24rem;
  }
  .icon_item{
    float: left;
    width: 1.42rem;
    height: 1.42rem;
    margin-right: 0.5rem;
    background-image: url(../../static/images/pxcx_icons.png);
    background-size: 3.21rem 3.21rem;
  }
  .icon_item.i1{
    background-position: -1.7rem -0.1rem;
  }
  .icon_item.i2{
    background-position: -0.1rem -1.7rem;
  }
  .icon_item.i3{
    background-position: -0.1rem -0.1rem;
  }
  .icon_wrap{
    margin-top: 0.5rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/pxcx.vue